export default [{
  path: '/MaterialHisM1th',
  name: '1thPage',
  component: () => import('@/view/History/1th.vue') //第一届
},{
  path: '/MaterialHisM2th',
  name: '2thPage',
  component: () => import('@/view/History/2th.vue') //第二届
},{
  path: '/MaterialHisM3th',
  name: '3thPage',
  component: () => import('@/view/History/3th.vue') //第三届
},{
  path: '/MaterialHisM4th',
  name: '4thPage',
  component: () => import('@/view/History/4th.vue') //第四届
},{
  path: '/MaterialHisM5th',
  name: '5thPage',
  component: () => import('@/view/History/5th.vue') //第五届
},{
  path: '/MaterialHisM6th',
  name: '6thPage',
  component: () => import('@/view/History/6th.vue') //第六届
},{
  path: '/MaterialHisM7th',
  name: '7thPage',
  component: () => import('@/view/History/7th.vue') //第七届
},{
  path: '/MaterialHisM8th',
  name: '8thPage',
  component: () => import('@/view/History/8th.vue') //第八届
},{
  path: '/MaterialHisM9th',
  name: '9thPage',
  component: () => import('@/view/History/9th.vue') //第九届
},{
  path: '/MaterialHisM10th',
  name: '10thPage',
  component: () => import('@/view/History/10th.vue') //第十届
},{
  path: '/MaterialHisM11th',
  name: '11thPage',
  component: () => import('@/view/History/11th.vue') //第十一届
},{
  path: '/MaterialHisM12th',
  name: '12thPage',
  component: () => import('@/view/History/12th.vue') //第十二届
},{
  path: '/MaterialHisM13th',
  name: '13thPage',
  component: () => import('@/view/History/13th.vue') //第十三届
},{
  path: '/MaterialHisM14th',
  name: '41thPage',
  component: () => import('@/view/History/14th.vue') //第十四届
},{
  path: '/MaterialHisM15th',
  name: '15thPage',
  component: () => import('@/view/History/15th.vue') //第十五届
},{
  path: '/MaterialHisM16th',
  name: '16thPage',
  component: () => import('@/view/History/16th.vue') //第十六届
},{
  path: '/MaterialHisM17th',
  name: '17thPage',
  component: () => import('@/view/History/17th.vue') //第十七届
},{
  path: '/MaterialHisM18th',
  name: '18thPage',
  component: () => import('@/view/History/18th.vue') //第十八届
},{
  path: '/MaterialHisM2015',
  name: '2015Page',
  component: () => import('@/view/History/2015.vue') //2015  夏洽会
},{
  path: '/MaterialHisM19th',
  name: '19thPage',
  component: () => import('@/view/History/19th.vue') //第十九届
},{
  path: '/MaterialHisM2017',
  name: '2017Page',
  component: () => import('@/view/History/2017.vue') //2017  夏洽会
},{
  path: '/MaterialHisM20th',
  name: '20thPage',
  component: () => import('@/view/History/20th.vue') //第二十届
},{
  path: '/MaterialHisMAll',
  name: 'AllPage',
  component: () => import('@/view/AboutCifi/HisCifiPage.vue') //历史回顾
}]




// WEBPACK FOOTER //
// ./src/router/history.js